import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { FolderIdPayload } from 'Interfaces/Folder';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: FolderIdPayload) =>
    $actions.folder.getFolder(dispatch, payload),
  );
};
